import { fundingOptions, getThemeColors, getUSANumberFormat } from "app/utils/utils";
import IPPageNumber from "../IPPageNuber";
import { Chart } from "primereact/chart";
import { barGraphOptionsFunding } from "app/uicomponents/macrocomponents/PlansSummary/config";
import { getSessionStore } from "app/utils/sessionStore";
import HexagonImg from "../../images/hexagonImg.png";
import { getColorVariations } from "app/utils/colorUtils";
import { useContext } from "react";
import { ThemeContext } from "styled-components";

const IPFunding = ({
  graphData,
  pageNumber,
  isNewPage,
  tableData,
}: {
  graphData?: any;
  tableData?: any;
  pageNumber: string | number;
  isNewPage?: boolean;
}) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { primaryColor, secondaryColor, ipTooltipColor } = getThemeColors(branding);
  const { isDarkMode } = useContext(ThemeContext);
  const limitedGraphData = graphData?.slice(0, 10);
  const tableHeaders = [
    { header: "Plan Year" },
    { header: "Annual Life Premium" },
    { header: "Annual Disability Premium" },
    { header: "Total Annual Premium" },
    { header: "Plan Fees" },
    { header: "Origination Fees" },
    { header: "Total Plan Costs" },
  ];

  const getVariationColor = getColorVariations(secondaryColor, tableHeaders.length);
  const variationColor = getVariationColor.reverse();
  const datasets = [
    {
      backgroundColor: fundingOptions(primaryColor)[0].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.lifePolicyPremium),
      label: "Life Premium",
    },
    {
      backgroundColor: fundingOptions(primaryColor)[1].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.disabilityPolicyPremium),
      label: "Disability Premium",
    },
    {
      backgroundColor: fundingOptions(primaryColor)[2].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.adminFees),
      label: "Plan Fees",
    },
    {
      backgroundColor: fundingOptions(primaryColor)[3].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.planOriginationFees),
      label: "Origination Fees",
    },
  ];

  const mainContent = () => {
    if (isNewPage && tableData) {
      return (
        <div>
          {pageNumber === "4" ? (
            <div
              className="text-xl font-bold mb-2 text-center conthrax-font"
              style={{ color: "#495057" }}
            >
              Business Costs
            </div>
          ) : null}
          <table className="w-full border-collapse">
            <thead>
              <tr>
                {tableHeaders?.map((item, index) => (
                  <th
                    key={item?.header}
                    className="p-1 text-center text-xs font-semibold text-white pdf_table_border border-white"
                    style={{ backgroundColor: variationColor[index] }}
                  >
                    {item?.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((policy: any, index: any) => (
                <tr key={index} style={{ backgroundColor: "#EEEEEE", color: "#000000" }}>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    {policy?.planYear}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.annualLifePremium, false)}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.annualDisabilityPremium, false)}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.totalAnnualPremium, false)}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.annualAdminFees, false)}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.planOriginationFees, false)}
                  </td>
                  <td className="p-1 text-sm text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.totalPlanCosts, false)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div>
        <div style={{ width: "503px" }}>
          <Chart
            type="bar"
            data={{
              labels: limitedGraphData?.map((item: any) => item?.planYear),
              datasets,
            }}
            options={barGraphOptionsFunding(false, ipTooltipColor, "Plan Year", "", "Plan Year")}
            key={`${isDarkMode}`}
            width="503px"
            height="450px"
          />

          <div className="flex flex-wrap justify-center gap-3">
            {datasets?.map(({ backgroundColor, label }, index) => (
              <div key={index} className="flex items-center">
                <span style={{ color: "#000000", fontSize: "16px" }}>{label}</span>
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor,
                    marginLeft: "2px",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20 px-[4em] w-full max-w-[56em] mx-auto p-[1.75em]">
        {!isNewPage ? (
          <h1 className="text-center text-2xl font-bold mb-5 conthrax-font interactive-proposal-text">
            Plan Funding
          </h1>
        ) : null}
        {mainContent()}
      </div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
          }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default IPFunding;
